module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("I")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MONSTERS WANTED")])]), _vm._v(" "), _c('div', {
    staticClass: "chapterEpigraph"
  }, [_c('p', {
    staticClass: "chapterEpigraphText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In which the author defines his vampire quest, dresses in a stinky mummy costume, watches too many movies, and then throws up.")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("W"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ATCHING MY OWN")]), _vm._v(" blood drip down the bathroom mirror, there’s only one thought running through my head: In a lifetime of questionable decision making, this is not one of my finer moments.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Like many things in life, it started off with the best of intentions. It was an experiment—a quest, actually. When I set out to write about the history of vampires, I decided to pursue three specific tasks. It seemed to make sense—in order to truly understand vampires and what they mean, I’d not only have to do the usual research and reading, but I’d have to find ways to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("experience")]), _vm._v(" vampires as well.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The gore sprayed all over my bathroom was the result of the last of these undertakings: to drink blood. The whole blood-drinking thing, as you can imagine, posed several problems.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Most of these difficulties were rooted in the particulars. In my book, to drink something means to take a mouthful of something and to swallow it—“tasting” or “sipping” wouldn’t be acceptable. This, of course, requires a sufficient quantity of blood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even though blood fetishists don’t advertise their gatherings in the Sunday paper, they aren’t particularly hard to find. However, anyone willing to let me drink their blood probably isn’t someone whose blood I should be drinking.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then I got an idea: I could drink my "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("own")]), _vm._v(" blood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I imagine you are full of questions.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It’s pretty simple, actually.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("If you look at every culture, throughout history, they’ve all had some variation on the vampire. Very few have been called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vampires,")]), _vm._v(" but every culture has some type of a supernatural creature that comes back from the dead and draws its power by preying on the living. Are there such things as actual vampires in the world? I’ve never seen one—nor has anyone I’ve ever known or met. Yet you can go to just about anyone, anywhere in the world, mention the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vampire,")]), _vm._v(" or show them a picture of some ashen-faced bad guy with fangs and a long cape,"), _c('span', {
    staticClass: "footnoteRef"
  })]), _c('span', {
    attrs: {
      "href": "#/footnote1",
      "id": "footnote1",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])]), _vm._v(" and they’d know what you were talking about.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Vampires are a lot like Santa Claus—each culture morphs the lore to fit its own needs and values. England has Saint Nicholas, Greece has St. Basil, Holland’s Sinterklaas arrives on a ship, French children wait for Père Noël, Italy has the good witch La Befana, and in China, Dun Che Lao Ren brings presents to children every winter. That said, St. Nick doesn’t have a fondness for sucking blood out of the necks of virgins. Well, if he does, he’s done a good job of keeping it on the down low.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This all started one morning during breakfast. I was pleasantly munching on a longtime favorite, Count Chocula, while CNN played on the TV. A story came on about energy costs and President Bush was offering a solution: destroy all vampires. Energy vampires, that is. The president was blasting cell-phone and computer manufacturers who used power chargers that drew electricity regardless of whether the device was actually using or storing it. These were commonly known as “energy vampires” and the president was urging Americans to solve the world’s power crisis by unplugging their cell phones once they were finished charging.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Looking away from the screen and down toward a magazine I was pretending to read, I turned the page and saw a vodka ad featuring a woman with a cape and long fangs. The ad encouraged potential vodka purchasers to “drink in the night.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even in my early-morning sleepiness, I stopped to consider this for a moment: Within a five-minute period, I’d encountered three references to vampires, of all things. This might make sense around Halloween, but it was early July.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Why vampires?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As I pondered this over the following days, I began to realize that I saw direct or indirect mentions of vampires everywhere—in an interview in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rolling Stone,")]), _vm._v(" during an episode of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seinfeld,")]), _vm._v(" a song lyric, a conversation on a plane. Vampires are invoked as metaphors all the time. It’s hard to go through a single day without seeing some reference to vampires.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So if the vampire is that ubiquitous…how did this happen? Why did it happen? I wanted insight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There are two basic ways to experience history.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Basic Way #1:")]), _vm._v(" Sit in a dark library and read old, smelly books that put you to sleep. I am not an advocate of this Basic Way; it isn’t very fun. Plus, this is definitely not one of those books.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Basic Way #2:")]), _vm._v(" History isn’t static. Most history reverberates through time, making things different than they’d otherwise be. Therefore, it’s important to understand it as it survives and resonates today. According to this Basic Way, to experience living history one needs to…live it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So to truly undertake my quest to understand vampires, I’d have to go out in the world and encounter them firsthand. This required a little prep, which led me to these tasks.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Which led me to drinking my own blood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Which led me to vomiting all over my bathroom.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Which led me to the first thing I’ve learned in this quest: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I am a total fucking idiot.")])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "Images/sp.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EOPLE ARE AFRAID")]), _vm._v(" of the dark.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It isn’t the absence of light that messes with your head, it’s the possibility contained in darkness. In the shadows you can find anything. You could step right up to a grizzly bear, evil marauder, or four-hundred-foot cliff and never know it’s there. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Not")]), _vm._v(" knowing is what makes your heart beat faster.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That’s where monsters come in. There is no evidence that monsters exist—vampires or otherwise. Yet despite this, we all cringe in scary movies. Clearly, there is nothing hiding in the closet, but we still make sure the door is closed before going to bed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Monsters always start off in darkness: a strange noise, a feeling of presence. We imagine them at their most horrific. That’s why good horror movies never show you the monster during the first act—what we imagine them to be is infinitely scarier than what they actually are.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eventually, the monster leaves the darkness and comes into full view. And what do we see?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ourselves.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We create monsters for all kinds of reasons. They’re often the result of our own misguided ways. They offer vengeance for our follies. They are metaphors for our worst fears: The Blob represents concerns about pollution and the spread of Communism, the Swamp Thing symbolizes the cultural separations between the North and South, Frankenstein stands in for our fear over the clash between medical innovation, ethics, and religion. King Kong embodies the fear and helplessness of the Great Depression. Godzilla signifies concerns over the danger of nuclear technology. The most ubiquitous monster of all isn’t the one who fills the darkness around us, but the darkness within ourselves: the vampire.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The vampire is the only monster that people actually "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("want")]), _vm._v(" to be. You won’t find much desire to be a mummy or zombie. You’ll never experience envy at the powers of the Frankenstein monster. No one ever wants to become a ghost or werewolf. Becoming any other type of monster is a curse, becoming a vampire is a key to power and a way to control what we fear.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When I started on my quest’s first task, it wasn’t fear I felt, but dread.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This questing nonsense started out as an attempt to discover vampires the way that most people do, through movies. I decided to watch every vampire movie ever made—all six hundred and five of them. It surprises many people that not only is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dracula")]), _vm._v(" the most adapted story in film history (there have been forty-three sequels, remakes, and adaptations of the story), but Count Dracula recently surpassed Sherlock Holmes as the character portrayed in film more than any other. On top of all those, there are several hundred films and TV movies featuring other vampire characters. All told, six hundred and five—and I planned to watch every one.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I started with the easy choices that everyone knows, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dracula")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nosferatu,")]), _vm._v(" along with some more contemporary fare like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Interview with the Vampire, Near Dark,")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blade.")]), _vm._v(" However, only thirty-six movies into my viewing the quality of the movies was becoming a bit thin, including such gems as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Little Vampire, My Grandfather Is a Vampire,")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("It! The Terror from Beyond Space.")]), _vm._v(" To compound things, as is my usual idiotic style, I announced this task to almost anyone who’d listen. While I may have been able to back out if I’d kept my mouth shut, on this one, I was committed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("Today’s selection: the 1936 film "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dracula’s Daughter,")]), _vm._v(" which seems appropriate since yesterday’s selection was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Son of Dracula")]), _vm._v(" (the 1943 ham fest starring an aging Lon Chaney, Jr., as Count Alucard, the son of the infamous count). "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dracula’s Daughter")]), _vm._v(" was the sequel of the 1931 original "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dracula")]), _vm._v(" starring Bela Lugosi, literally picking up where "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dracula")]), _vm._v(" left off. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dracula’s Daughter,")]), _vm._v(" a mysterious countess, named Marya Zaleska, arrives in London to claim Dracula’s now completely dead corpse. When the authorities go to retrieve Dracula’s coffin, it comes up missing. At the same time, bloodless bodies are discovered nightly around London. It’s the countess—who, once discovered, hotfoots it back to Transylvania in a 1930s version of a high-speed chase with Scotland Yard. The countess ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("eventually takes a wooden arrow through the heart and all are safe once again (though no explanation is ever given for what happened to Dracula’s corpse and coffin).")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dracula’s Daughter")]), _vm._v(" was one of the original horror movie sequels and is on about the same cinematic level as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Halloween 5")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bride of Chucky")]), _vm._v(". On almost any aesthetic scale, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dracula’s Daughter")]), _vm._v(" bears no similarity to the original. Gone are the originality, dark gothic imagery, eerie passages of silence, and subtexts of sexual repression and fear of technology. Replacing it are campy attempts at humor, melodrama, and painfully obvious sexual innuendo. The pacing is slow, with long bouts of over-the-top dialogue. The so-called suspense scenes are anything but, due in large part to the overly schmaltzy soundtrack that gives everything away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Watching all these films has led to my first major discovery about vampire movies: They suck.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I’m not trying to make some clever use of puns here; by and large vampire films are not good movies when viewed today. Watching almost any vampire movie in a contemporary context, even the 1931 original "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dracula")]), _vm._v(" or the first vampire film, the silent "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nosferatu,")]), _vm._v(" is an exceptionally disappointing experience. There’s a reason for this: Vampire films capture the fears, desires, and values of their time in a way that doesn’t age well. It’s like platform shoes or beehive hairdos—things that seem hip and cutting edge at one time, end up looking ridiculous in hindsight. What once was horrifying, now seems overblown, melodramatic, and kitschy.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("Vampire films, books, and the undead’s appearances in contemporary culture are the same way. Most vampire lore suggests that vampires don’t cast reflections in mirrors. Yet, vampires are reflections. Vampires reflect our desires, dark ambitions, fears, longings, and despair. Vampires equally represent what represses us and what sets us free. The blood-drinking undead provide a stark example of what makes societies and cultures unique and different. They are the perfect metaphor. As vampire scholar Nina Auerbach wrote, “Every age embraces the vampire it needs.” However, ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("none of these deep thoughts are making "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rape of the Vampire")]), _vm._v(" any easier to watch.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rape of the Vampire,")]), _vm._v(" along with films such as the 1952 Bela Lugosi stinker, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("My Son, the Vampire,")]), _vm._v(" leave viewers puzzled as to how the movie they’ve just viewed has any connection with its title. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("My Son, the Vampire,")]), _vm._v(" Lugosi plays an evil vampire scientist building a killer robot to take over the world."), _c('span', {
    staticClass: "footnoteRef"
  })]), _c('span', {
    attrs: {
      "href": "#/footnote2",
      "id": "footnote2",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])]), _vm._v(" While there was a character named Mother Riley, there appears to be no son in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("My Son, the Vampire")]), _vm._v(". Likewise, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rape of the Vampire")]), _vm._v("—there is no rape.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I’m not sure what "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rape of the Vampire")]), _vm._v(" is supposed to tell me about life, culture, or the filmmaker’s view of the world. That is, besides that he must have had a thing for breasts. From what I was able to follow, the film apparently tells the story of a group of beautiful vampire women. These vampires, who feed only from other women, can’t seem to manage a bite on the neck unless everyone involved is naked from the waist up first. One of the vampires falls in love with a mortal man who wants to become a vampire himself. Then it seems everyone is desperately trying to find a cure for vampirism. All this nonsense apparently upsets the head vampire woman, who looks and dresses more like an aborigine than a vampire. The characters run around screaming and crying for a while, and then everyone dies.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It’s a 1960s French film, which should explain everything.")]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "Images/sp.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("Y SECOND PREVAMPIRE-HUNTING")]), _vm._v(" task was to understand what it means to be a vampire. I wanted to walk in his shoes, wear his cape, sleep in his coffin—whatever.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This quest was easy to accomplish, because I’d already done it. I was a vampire, once. Well, for a weekend, more or less.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I was thumbing through the car ads in the paper one late summer morning and a classified caught my eye. It featured a poorly drawn Grim Reaper over the bold-faced headline "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("MONSTERS WANTED")]), _vm._v(". It was an ad for the House of Terror, a haunted house located in an unused school building. The want ad promised “fun, excitement, and $$$” for “responsible actors” interested in portraying characters in its facility.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After reading the ad, I went on with my day, but I kept thinking about it. As a kid, I loved going to haunted houses and had always thought it would be awesome to actually work in one. Whenever I’d catch a glimpse of the people working in haunted houses, they always wore chain wallets, Aerosmith or Led Zeppelin T-shirts, and looked pretty mean and frightening even without the masks and props. The coolest of the cool were the kids who played vampires. They got to scare the hell out of visitors by jumping out of a closed coffin, grabbing a hot-looking girl (another haunted house employee), and biting her neck. They were scary and cool, and I fantasized about being one of them. Specifically, I wanted to be the girl-grabbing, neck-biting vampire. Now, more than twenty years later, here was my big chance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After dinner that night, I fished the paper out of the recycle bin and called the number listed. The recorded message indicated that interested applicants should show up at the House of Terror at exactly 8:00 "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("A.M.")]), _vm._v(" on the Saturday of Labor Day weekend with proper ID and a social security card. It informed callers that the process would take the better part of the morning. The message warned that no one would be admitted before eight and anyone showing up late would be turned away. Without discussing it with anyone, I just scooted out of the house that morning and headed over.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("I figured that since it was a holiday weekend, turnout would be light. I further assumed that the “responsible actors” would be other fun-loving haunted house enthusiasts like me looking for something interesting to do as well as a part-time paycheck. As soon as I was within sight of the House of Terror, I began to realize how mistaken I was. It wasn’t even 7:30 "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("A.M.")]), _vm._v(" and there were at least two ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("hundred people lined up outside the building. To someone driving by, they might sum up the assembled crowd as people you’d expect to respond to a “free tattoo” or “free mullet trimming” offer rather than an employment ad. They didn’t look like vampires, werewolves, and ghouls—they looked like carnival ride operators.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At a few minutes after eight o’clock, a guy emerged, identified himself as Tom, and led us into the old school’s cafeteria to fill out our applications. Before we started, Tom told us we were to stay in our seats while we filled out our applications. We were not to get up and move around, not even to go to the bathroom. Once we were finished with the applications, we’d be taken out—one table at a time—to the interview area, where we’d be individually interviewed by one of the house’s managers. Another manager, named Sue, told us that anyone who turned in an incomplete application, left the room, got up to talk to others around the room, fell asleep, smoked, drank, or ate, would be immediately rejected and sent home. Sue also gave a rundown of what was expected. Most of the rules would be covered at orientation, she said, but going over the basics might save us all some hassle. The houses would be open 8:00 "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("P.M.")]), _vm._v(" to midnight on Thursday through Sunday and every “actor” would be required to work both Friday and Saturday nights plus one other night. Each actor would have to show up one hour before work and stay one hour afterward. Pay was sixty dollars a week, paid only if the actor completed all their assigned shifts. Lastly, actors wouldn’t be employees, but independent contractors.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And another thing,” Sue said. “You can pick the role you play, but forget about being a chain saw guy—those roles fill up with returning actors.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I wanted to ask about the demand for vampires, but I was too caught up on the sixty dollars. Three nights a week, six hours a shift—that’s barely three dollars an hour. So much for the promised “$$$,” which was apparently as subjective as the “fun and excitement” and the definition of “actor.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("There were eight guys sitting at my table. I had completed my application in about five minutes and was the first one finished by ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("at least ten more minutes. The task seemed very difficult and taxing for my tablemates. To be honest, it looked like almost any task would be taxing for my tablemates. It seemed that the act of getting out of bed and being here at 8:00 "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("A.M.")]), _vm._v(" had sucked all the energy out of them. Three of them had violated the “no sleeping” rule within the first twenty minutes.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Our table was in the back corner, and since people were being interviewed table by table (starting at the other end of the room), we knew we’d be there for quite some time—well more than an hour at the rate things were going. After my tablemates had struggled through recalling their names, addresses, and meager employment histories, we started to chat among ourselves. Our applications finished, a conversational hierarchy soon emerged at our table. Our moderator was a guy named Steve, who decided what we’d discuss, for how long, and passed judgment on who was “full of shit.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Steve raised his hand and was reluctantly acknowledged by Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Say, how do you want me to list my service—by assignment or branch, or the time I was in the army?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It doesn’t matter, just write it down,” replied Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Steve turned back to us and interrupted the conversation to tell his third military story in the past ten minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I was over in Iraq for the Gulf War, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Yes, we did know. He had told us this at the beginning of every story.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The whole time I was over there, all I could think about was eating fried chicken,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I kept thinking that the thing I really missed about home was fried chicken and I kept asking the mess guys if they would ever make fried chicken. They never did. Then, right before we headed home, the cooks made some shitty fried chicken. I figured, ‘What the fuck,’ and got a huge plate full of fried chicken.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("“I was so happy to have fried chicken and told all my buddies to chill while I ate some. My one buddy thought he’d be real funny and moon me while I was eating. So he walks right up to me, right, ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("and drops his pants and spreads his butt cheeks—right there in front of me. And I said, ‘Man, what the fuck, all I want to do is eat my fried chicken.’ He just laughs and wiggles his butt in my face.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I was so mad, ’cause I had been looking forward to eating fried chicken for weeks. So I picked up a chicken bone and stuck it up his ass. Right up there. Man, was he mad.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We were all laughing when Tom came over to settle us down. He warned Steve that using profanity could get him ejected and he should consider that his warning. He told us to just sit down, shut up, and wait.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Around the room were several photocollages of actors from past seasons in their costumes. Basically, all the characters were a collection of weapons, torn clothing, stage blood, and various foreboding props. In each group there would be one or two people who stood out—white skin, slick hair, black clothes, and fangs. The vampires.")]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "Images/sp.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("V"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("AMPIRES ARE SO")]), _vm._v(" easy to pick out because there isn’t any other horror archetype that’s so immediately recognizable. Not simply by look, but actions as well.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The vampire we think of today came from the undead legends of Slavic nations such as Serbia, Hungary, and the infamous Transylvania. Most people assume our contemporary vampire originated there, but that isn’t entirely true.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Our modern understanding of vampires did flourish in Eastern Europe, but got its start in Greece.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Following a long Christian tradition of coopting pagan and folk traditions, the Greek Orthodox Church took the country’s various legends of blood-sucking undead and used them to reinforce Church doctrine. As a result, for many centuries there was scarcely a Greek village that didn’t have some sort of local vampire story.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("In the eighth century, the Greek Church declared that the bodies of those excommunicated by the Church would not decompose ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("until they had been granted absolution. While former members were in this state, they were doomed to wander through the world, feeding off the blood of the living. Very frequently, the graves of suspected vampires were opened and the bodies were found with ruddy complexions and veins distended with blood. When lanced, large quantities of blood would pour out of the body, blood presumably drawn from the bodies of young, fresh human beings.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The belief became so popular in Greece that the Church expanded the declaration to murders, suicides, those guilty of heinous sins, practitioners of the magic arts, and anyone cursed by their parents. Whenever something bad happened or an unexplained illness or death fell upon a friend or neighbor, people would immediately cast about looking for a recently deceased local black sheep to blame. Their only course of action would be to campaign for the Church to grant absolution or dig up the offender, drive a stake through his or her heart, and burn the corpse. Until recently, the Catholic liturgy for excommunication still included the sentence, “After death, let not thy body have power to dissolve.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fueled by the endorsement of the Church, vampire lore began to spread throughout Europe. Most of the early tales weren’t created through folklore, but by bragging priests and bishops. Many Church officials of the time wrote of their experiences encountering and dispensing with vampires who were once excommunicated pirates, thieves, murderers, harlots, and other undesirables.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Logical assumptions started to emerge in the lore. If the vampire’s fate was controlled by the Church, the belief surfaced that vampires would cower when confronted by crosses or other religious symbols.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("As the belief in vampires spread throughout Europe, the lore became more sophisticated. The blood-sucking undead became the scapegoats for all types of misfortune, including stillborn children, unexpected death, bad weather, disease outbreaks, and even impotence. Maladies such as severe nightmares, migraine headaches, and wasting disease were all blamed on vampire attacks. As the beliefs and abilities of vampires grew, so did the methods that could turn ")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("someone into a vampire. In addition to excommunication, evil deeds, and untimely death, it was commonly thought that vampirism could be spread like a disease. Once one person in a community rose from death, it was thought that his curse could be spread through his attacks, especially his bite. Some stories stated that the curse could be spread by consuming meat from cows fed upon by vampires. Some thought that vampirism was hereditary—after one member of a family turned, others in the same family would meet a similar fate after death.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("Once otherwise unexplainable happenings were blamed on a vampire, oftentimes a village or city would fall into a vampire hysteria, attempting to link almost any unusual happening to their undead interloper. For example, in the spring of 1727 in the Serbian city of Meduegna (near modern-day Belgrade), a young man named Arnod Paole, about to be married, died shortly after falling from a horse. Within a few weeks of his death, several young women in the town died. The locals were convinced that Arnod had come back from the grave as a vampire, due to his untimely and unfortunate death, and was spreading his grief among his neighbors by feeding off their blood. Fearing the worst, the villagers dug up Arnod’s body and found that his body looked pink and lifelike, and his hair and nails had grown longer. There were also traces of blood around his mouth. Local authorities quickly staked and burned Arnod’s body and returned it to his grave. Just for good measure, they also staked four other recently deceased townspeople, fearing that they may have been Arnod’s victims and might soon come back to wreak havoc as well. Over the next five years, the villagers logged more than a dozen incidents that they attributed to Arnod’s brief tenure as their local undead. Two women dying of what is now known as tuberculosis claimed to have drunk Arnod’s blood and were eventually staked and burned after their deaths. Family members of a deceased eight-year-old child dug him up after a few months and drove a stake through his heart after finding an unusually healthy-looking corpse. Three other men were found with large quantities of blood in their ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("corpses after death and were staked for good measure. Things got so out of hand in Meduegna that almost all of the deceased locals were dug up, staked, turned facedown in their graves, or had their mouths stuffed with herbs and garlic to prevent them from spreading their evil among the living.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The residents of a nearby village became so freaked out that vampirism might spread to their town that they were forced to gather together in two or three houses every evening, burning candles and taking turns watching over the others. In order to make sure everyone kept to their anti-vampire routines, some of the village leaders would cast their shadows against the buildings, howl and shriek in the night, and leave spatters of blood and cow dung in abandoned houses.")]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "Images/sp.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("W"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("E SAT AROUND")]), _vm._v(" the House of Terror cafeteria for about another twenty minutes before our table was called. Once we reached the front of the interviewing line, we saw four tables, with two managers on one side and an interviewee on the other. The interviewee would take a seat, then some questions and polite conversation would go back and forth. At the end of each interview, the interviewee would scream, thank the interviewers, and leave.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("When my turn came, I answered the standard questions,"), _c('span', {
    staticClass: "footnoteRef"
  })]), _c('span', {
    attrs: {
      "href": "#/footnote3",
      "id": "footnote3",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])]), _vm._v(" but my mind was on the scream. What was it for? Would I have to scream? Would I be asked to scream, or was it just something that one person did to impress the managers, then others started to follow suit?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then, one of the managers told me that being an actor in a haunted house was tough, thankless work. I’d have to perform for hundreds, if not thousands of people a night, and I’d have to give "), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("as good a performance to the last person as I had to the first. As a sign of my acting skills, she asked for my best scream.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Now?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes,” she responded, looking confused, as if she wondered how I had missed the seventy other screams that morning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay, what am I screaming at?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry, like…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I mean, what is my motivation?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“For screaming?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Because I told you to.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fair enough. With that, I let out my best scream. Well, it was a shriek, actually. The kind of high-pitched shrill yelp you’d expect from a teenaged girl when Jason or Freddy Krueger jumps out from behind the sofa.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My two interviewers looked at each other, then back at me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you want to try that again?” one asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Was that bad?” I responded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well,” said the other. “We’re kind of looking for scar"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("y")]), _vm._v(", not scar"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ed")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But I want to play a vampire,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s fine, but vampires scream, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why would a vampire scream?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Because we told him to.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I tried again. Slightly better, though still hoping anyone I know didn’t hear me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Very nice, you can expect a call next week.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So, I’m in?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’ll call you if we need you,” she replied, extending her hand in an obvious gesture that meant our time together was over.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("A week went by with no call. Then another week went by—nothing. They said that there would be only seventy-five hires, but I figured that even with my girly scream, I could at least make the ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("top quartile. After waiting a few more days, I called Tom. He found my application, paused while he read over the notes, and told me that they were all full and didn’t need me.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You can try again next year,” he offered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Will you have any openings later on this season?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure,” he responded. “Just give us a call later on.” He paused and stuttered, obviously trying to backpedal. “But, you know, we had lots of qualified applicants, you may be pretty far down on the waiting list.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Qualified applicants? I am a college graduate and a published author. I have been steadily employed since I was sixteen. I wondered how seventy-five Ph.D. Mensa members had snuck through the application process that day without me noticing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I followed Tom’s advice and checked back the next week, and every week thereafter, until the middle of October. Finally Tom, probably more annoyed with my constant phone calls than anything else, told me to come to training on Thursday night.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When I arrived, I found the other actors starting to get into their costumes, I found Tom and asked what I was supposed to do.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We need a mummy. Why don’t you put on that stuff,” he replied.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you need any vampires, instead?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, only have a few, but they’re taken care of. Do the mummy and we’ll see what we can do for you next time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The mummy getup involved applying tan pancake on my face, then slipping into a set of thermal underwear with rags sewn on it. The ripe odor coming off the costume indicated it had been used several times by others since its last cleaning. That is, assuming there had been a previous cleaning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I had just finished applying the makeup and dreading the thought of slipping into my stinky mummy gear when Tom came up to me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Seems you’re in luck,” he said. “One of the vampires didn’t show up tonight, so you can take his place if you like.”")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Because of my interest in being a vampire and lack of interest in wearing that thermal underwear, I enthusiastically accepted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You can just put on this suit and meet me on the third floor. Make it quick.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What about my face?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There are fangs in the costume supply box,” he replied.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But my face is brown,” I replied.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who has ever heard of a tan vampire? Vampires can’t be in the sun to tan.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No one will care, just get in the suit and meet me upstairs.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I took a look at the suit. It was a gray tuxedo, a wrinkled white dress shirt—and a dickey. Worse yet, a white dickey with red-tipped fringe.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ah, Tom…I’m supposed to wear this?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, what’s wrong with it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What’s wrong? No self-respecting vampire would be caught in anything but a crisp black tailcoat. Wearing this, I wouldn’t look like a vampire; I’d look like a prom king from 1978, a well-bronzed one at that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is all wrong,” I said. “No one’s going to think I look like a vampire in this.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Listen, fella,” Tom said, pretending to care. “It’s the fangs that make it, plus the coffin.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But there’s no cape.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You don’t need a cape, just put it on and come upstairs.”")]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "Images/sp.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("“O"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("KAY")]), _vm._v(",” T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OM SAID")]), _vm._v(" once I’d arrived in my tuxedo and plastic fangs. “When they leave the Hall of Mirrors, you’ll hear their footsteps. If you look through this hole in the side of the coffin, you’ll see them comin’ in to your room. That’s your cue to sit up in your coffin and scream. Then you lie back down.”")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No biting anyone?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” Tom replied, not understanding where I was going. “Just jump up and swing this stake at them.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tom handed me a wooden stake lying next to the coffin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I")]), _vm._v(" threaten "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("them")]), _vm._v(" with the stake?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, just throw open the lid, scream, and point this stake at them.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But the stake is supposed to kill the vampire, not his victims.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you want people driving stakes through your heart?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then you hold on to that stake and swing it at them.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("About fifteen minutes later, the house opened and I could hear people working their way through the House of Terror. I grabbed my stake, positioned myself inside the coffin, shut the lid, and waited.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I hunkered down and looked out the coffin’s peephole until I could see the outlines of bodies. I threw open the lid, sat up, screamed, and waved my stake at them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They screamed. I laid back down.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At this point, I should share some sort of contextual anecdote about what it means to jump out of a coffin and scare someone. That’s supposed to be the whole point of this adventure. However, there really wasn’t anything deep about it at all. I screamed, they screamed. It was fun. In fact, it was really fun. I was a vampire, and I couldn’t wait for the next group to show up so I could do it again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My joy slowly dissipated as the evening wore on. Since I was lying down in the coffin and then bolting up to a sitting position, I was basically doing a sit-up. Just like doing regular sit-ups, the first few were no problem. But after the first dozen groups, I realized that this was going to be a workout.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After the second dozen, my screams of “Aaaaargh!!” switched to “Agh.” After a few more, my “Agh” became more like an “Ugh.” By 11:00 "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("P.M.")]), _vm._v(", I was opening the lid, propping myself up with my arm, lazily waving my stake, and lying back down.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("The repetition was numbing. I’d get up, make some kind of ")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("noise, wave the stake, and they’d scream. As the evening dragged on, the screams were getting less frequent, occasionally replaced with looks of pity and sympathy.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After one late group right before closing, I was back inside the coffin when I heard a noise. Just as I was about to look out the peephole, I heard a large thud on the top of the coffin. I tried to open the lid to see what was going on, but I couldn’t open it. I tried pushing, hitting, kicking—nothing. I was stuck.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I started to scream—for real. The coffin was pretty large—two people could have fit inside of it. But lying there, trapped inside, it started to feel smaller and smaller. I felt as if I couldn’t breathe and fell into a complete panic.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What I was experiencing, or just the idea of experiencing being trapped inside a coffin, is an important component of vampire lore. Being trapped inside a coffin, struggling to get out, explains why different cultures and societies created vampires instead of demonic groundhogs or evil magic broomsticks. It fit the fear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Modern medicine and diagnostics can blind us to the fact that in the past, declarations of death were commonly less than certain. To the unsophisticated observer, someone in a coma or the end stages of terminal illness may appear to be dead, but may still be very much alive. If someone taken for dead, but only in a comatose state, was brought back to consciousness (often by grave robbers or the commotion during a wake), the witnesses were sure to think that the person was returning from the dead. As late as the 1920s, it was reported that on average one premature burial occurred in the United States "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("every week.")]), _vm._v(" And those were the reported ones.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Throughout history, especially before embalming practices became common, those who had cause to unearth the dead often surmised that there had been some struggle to escape from the casket. The corpses sometimes had distorted features and were found in twisted positions. Given the evidence—along with the refusal to believe that someone could be misdiagnosed as dead—the logical conclusion was that the deceased had come back from the dead and were attempting to leave the grave to attack the living.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("Further, many corpses were found to have rosy complexions and were slightly bloated. Many also appeared to have new hair growth, longer nails, and blood around the nostrils, mouth, and ears."), _c('span', {
    staticClass: "footnoteRef"
  })]), _c('span', {
    attrs: {
      "href": "#/footnote4",
      "id": "footnote4",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The conclusion? They were vampires—freshly filled with blood from hunting the living and grown gruesome from their evil activities. What to do? Drive a stake through their heart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In Eastern Europe, staking became a common practice not only for the undead, but for any recently deceased neighbor or relative. Initially, driving stakes through bodies and into the bottoms of wooden caskets was considered a preemptive measure. Not only would the deceased not become vampires, but if they did, they’d be pinned to their caskets and unable to get out. Staking was also considered a good way to ensure that the deceased were actually dead. At a funeral, a stake would be driven through a loved one’s chest. If they weren’t already dead, they would be after that. The practice spread throughout Europe. In the nineteenth century, it was common for wills to include a proviso that the deceased couldn’t be buried until their heart was pierced. It also became common to equip new coffins with interior release switches or methods to signal that the people buried inside were, in fact, very alive.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My coffin at the House of Terror contained no such method, except for my screams and kicking. After beating the coffin lid for what seemed like an hour, the lid suddenly popped open. A few other actors stood around laughing. It was part of some hazing that went on among the house’s actors—pranks on the new guy. They had all been victim of it and now it was my turn.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We heard some bumping coming through the Hall of Mirrors and all of them hightailed it out through the back way. More customers, more sit-ups, and more “Ughs.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The next morning I got a call from Tom, stammering his way through telling me that the regular vampire had come back to work and I wasn’t needed anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In so many words, my career as a vampire was over.")]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "Images/sp.jpg"
    }
  })])]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("BOUT FOUR WEEKS")]), _vm._v(" into my vampire movie watching, I realized that, while not even one-tenth of the way through the list, I was scraping bottom. Over seven days, I had viewed such cinematic wonders as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jesus Christ Vampire Hunter,")]), _c('span', {
    staticClass: "footnoteRef"
  })]), _c('span', {
    attrs: {
      "href": "#/footnote5",
      "id": "footnote5",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blacula")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Samurai Vampire Bikers from Hell,")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rockabilly Vampire")]), _vm._v(" (a low-budget tragedy in which the vampire is an Elvis impersonator), bringing my total movies viewed up to forty-eight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As is often the case with vampire movies, just when you think you can’t take it any longer, something hits you that is ultimately revealing about the filmmakers, their intended audience, and the moment in time the film captures.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Take "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blacula,")]), _vm._v(" the 1972 film that brings the Dracula bloodline to South Central. It tells the story of an African prince, named Manuwalde, who visits Dracula in 1780 and is turned into a vampire himself. However, Manuwalde is locked in a coffin soon after and lies dormant for almost two hundred years. In the 1970s, two gay antique dealers buy up the remnants of Dracula’s castle and transport them to Los Angeles, hoping to turn big profits. Once they get everything back to the States, they open Manuwalde’s "), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("coffin and out pops Blacula. He immediately feeds on the antique dealers and heads out in search of the reincarnation of his African lover, named Luva, who died waiting for him to return from Transylvania (and now is conveniently reincarnated as a black woman in South Central—since the princess’s bloodline was brought to the States via the slave trade). While he searches, the police figure out something is fishy and try to track down Blacula. At the moment he hooks up with Tina, his recycled sweetie, the cops show up and try to shoot Blacula, hitting Tina instead. Blacula swoops up Tina, carries her back to his coffin, and attempts to turn her into a vampire before she dies from the gunshot wound. Once the cops catch up, they find Luva-Tina in the coffin, and drive a stake through her heart, killing her. Blacula, despondent at losing Luva twice, throws himself into the daylight and is incinerated.")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("While the plot is simple and trite, it speaks volumes about cultural life in 1972 Los Angeles. In that sense, it’s classic blaxploitation. The movie’s racial undertones are obvious and easy. But there are several more subtle themes, such as the metaphors for slavery. Manuwalde was turned to vampirism by a European aristocrat and then imprisoned for more than two centuries. When he finally gains his freedom, nothing makes sense—he is an outsider in a society where people look and act similarly (most of the time), but he can never be their equal. Also Luva, dead as an African woman, is able to be “reawakened” through reincarnation as an African-American, once she is reunited with her African prince.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Another disturbing metaphor is captured in the humor and intolerance found in the characters’ attitudes toward the gay antique dealers. Soon after the cops discover the dead couple, the black antique dealer’s corpse disappears. When the police are informed, they respond by saying, “Who’d the hell want a dead faggot?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shortly after watching "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blacula")]), _vm._v(" I took a look at the next title in my pile, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Killer Barbies vs. Dracula.")]), _vm._v(" It was time for a break. That’s when I decided to pursue my final task—drinking blood. Specifically, my own.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("Blood is the essence of vampirism. It’s the universal symbol of ")]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("horror, death, and life that gives the vampire his power. The belief that blood is connected to the soul or life source of humans originated with the Egyptians as early as 2500 B.C. Throughout Eastern and Western cultures over the following 4,000 years, it was commonly believed that blood was the seat of the soul, connecting the spirit to flesh. In early societies, spectators would drink the blood of fallen warriors and gladiators with the hope of transferring some of their strength to the recipient.")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Despite an almost total lack of scientific understanding of what blood was or how it functioned, the ancients were more right than wrong. Blood, though it seems like a relatively straightforward substance, is amazingly complex. It is the biological glue that holds us together and keeps us alive. The average adult carries about 1.3 gallons of blood in his body, which has about a four-month life span. Though blood seems like a whole substance, it is actually made up of a bunch of different components, each with a unique purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Greeks believed that blood was one of four essential bodily fluids, along with phlegm, black bile, and yellow bile (a.k.a. the four humors). The Greeks also pioneered the practice of bloodletting as a form of healing. At the time, they believed that there was only one disease, kind of like a generic illness. The way to combat this illness was to restore a proper balance of all four basic fluids. The easiest to control was blood, so the Greeks initiated the practice of draining blood to heal sickness.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("In Western societies, the practice went in and out of vogue, but became especially common from the twelfth to nineteenth centuries. Before that, bloodletting was a religious endeavor, undertaken by clergy in an attempt to rid the body of demons. During the twelfth century, the Church decided it wanted out of the bloodletting business and turned it over to barbers."), _c('span', {
    staticClass: "footnoteRef"
  })]), _c('span', {
    attrs: {
      "href": "#/footnote6",
      "id": "footnote6",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])]), _vm._v(" Strangely, "), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("physicians at the time did not practice surgery, they considered the practice beneath them. Surgery and bloodletting were thought of as a last resort when other, more sophisticated forms of treatment, failed to produce results.")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The most favored method of bloodletting was via venesection (drawn from a vein) with the patient standing. The barber would draw out between sixteen and thirty ounces of blood (about a third of the blood in the patient’s body), depending on the ailment. The desired effect was lowered fever, a softer pulse, and faintness (of course, this was also a sign that the patient was dying, but why split hairs—dead patients no longer complain about illness, right?).")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By the late 1800s, bloodletting was falling out of fashion—not because it was an ineffective and barbaric practice, but because it went against the grain of scientific thinking of the era. Disease was thought to be the result of depression, something that could be overcome with a brighter attitude or outlook. Bloodletting tended to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cause")]), _vm._v(" depression in patients, so the practice was abandoned. While blood removal is still practiced as a treatment for some blood ailments, its use as a general treatment died out by the beginning of the twentieth century.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In addition to blood’s association with life, blood also has a long track record with religion. In addition to Christianity’s belief that the Eucharist involves drinking the blood of Jesus to receive spiritual redemption, many religious texts forbid the consumption of blood due to its role as a purifier. Especially Judaism, which uses this as one of the bases of kosher food preparation. The foundation of this originates in Leviticus 17:11: “For the life of the flesh is in the blood, and I have given it to you upon the altar to make atonement for your souls, for it is the blood that makes atonement for the soul.” All this only adds to the appeal of blood as part of vampire lore—not only is it the essence of life, it is forbidden fruit. Forbidden fruit that I wanted to sample.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("While at the doctor’s office for a routine physical, I asked if he wouldn’t mind drawing an extra vial of blood for me to take home. He declined, saying he didn’t think it was a very good idea. Well, ")]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("compared to my other options for getting a sufficient quantity of my own blood, I considered it pretty fucking stellar.")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I was buttoning my shirt after he left when I realized that the examining room’s supply cart was stocked with needles, vials, alcohol swabs, and cotton balls. I simply grabbed one of each and nonchalantly dropped them into my backpack before the nurse showed up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Back home, drawing the blood was easier than I expected. Of course, I had just witnessed a demonstration at the doctor’s office earlier that morning, so I picked a spot about an inch south from his and repeated what he’d done. Almost as soon as the needle pierced my skin, the vial started to fill with blood. No problem.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I figured the tough part was over.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("During my reading about blood-fetish practices, I’d often read that blood is much more tasty when chilled. Considering that, I pulled out some dusty barware, grabbed some ice, and poured the contents of my vial into a cocktail shaker.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I though it would be best to drink my blood neat and cleaned out a shot glass, which I then filled with my chilled bodily fluid.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I thought that if I pondered this too long, I’d talk myself out of doing it. So I raised my glass and took it all in one gulp before I had a chance to think about what I was doing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As soon as the blood passed into my throat, I realized how stupid an idea this was—as I could feel my breakfast coming up to meet it. Having been told to fast for twelve hours before having my blood drawn at the doctor’s office, I had stopped on the way home for a hearty breakfast.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I bolted for the bathroom and was just inside the door when a mixture of scrambled egg, Diet Coke, apple, bacon, and ice-cold blood exploded out of me all over the bathroom.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The results were surprisingly gory—worse than you’d think. There was blood and breakfast all over everything, as if Freddy Krueger had just dispensed with three cheerleaders moments ago.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("After taking a deep breath, I realized that I was as ready as I was going to get. I had all I needed to find the literal and figurative in")]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("fluence of vampires. Arguably, I’d been ready before I’d even started any of these ridiculous tasks. The world is filled with fear, mistrust, passion, and desire. Today in America, vampires are everywhere—and not just in the movies—from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sesame Street,")]), _vm._v(" fetish clubs, toy pencil sharpeners, advertisements, kids’ cereal boxes, and role-playing games to crossing your fingers as a gesture for someone to back off or go away.")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In an age of corporate-accounting scandals, pedophile priests-congressmen-whatever, African warlords, influence-peddling lobbyists, and terrorists—let alone various geeks, freaks, outcasts, and the normal people you pass walking down the street—vampires were everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I just had to look.")])])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page40"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-818fcd2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312371111_ch01.vue
// module id = 84
// module chunks = 0